import * as Sentry from '@sentry/vue';
import { inject as VercelAnalytics } from '@vercel/analytics';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { router } from './router';
import './style.css';

if (import.meta.env.MODE === 'development' && import.meta.env.VITE_MOCKS_ON === 'true') {
  const { worker } = await import('../mocks/browser');
  await worker.start();
}

const app = createApp(App);
const pinia = createPinia();

VercelAnalytics();

Sentry.init({
  app,
  dsn: 'https://68894e4dda4c8f352c1bb254e7887c98@o185486.ingest.sentry.io/4506741677490176',
  integrations: [Sentry.browserTracingIntegration({ router })],
});

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  Sentry.captureException(event.reason);
});

app.config.errorHandler = (err, vm, info) => {
  console.error('Error:', err);
  console.error('Vue component:', vm);
  console.error('Additional info:', info);
};

app.use(pinia).use(router).mount('#app');
